/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(5, 5)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()

  let spImgList = [
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p1.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p2.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p3.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p4.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p5.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p1-2.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p2-2.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p3-2.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p4-2.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p5-2.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p1-b.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p2-b.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p3-b.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p4-b.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p5-b.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p1-b-2.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p2-b-2.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p3-b-2.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p4-b-2.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-p5-b-2.png',

    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-b1.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-b2.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-b3.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-b4.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-b5.png',
    'https://cdn.shopify.com/s/files/1/0752/9975/0173/files/202508192-b6.png',
  ]

  new Swiper('.sp-swiper1', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 1,
    },
    spaceBetween: 22,
    speed: 6000,
    loop: true,
    slidesPerView: 'auto',
  })

  new Swiper('.sp-swiper2', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 0,
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: '.sp-pagination1',
      clickable: true,
    },
  })

  let _swiper = new Swiper('.sp-swiper-p1', {
    spaceBetween: 10,
    speed: 1,
  })
  let _swiper2 = new Swiper('.sp-swiper-p2', {
    spaceBetween: 10,
    speed: 1,
  })

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      let scale = document.body.clientWidth / 1080
      $('#root').css('zoom', scale)

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              let scale = document.body.clientWidth / 1080
              $('#root').css('zoom', scale)
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    preloadImages(spImgList)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        let _topHeight = $('.time-part').height() + $('.sp-header-top').height()
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            _topHeight * $('div#root').css('zoom') +
            10,
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()

  let sp_price1 = 23.99
  let sp_price2 = 49.99

  function calcTotal(price, num) {
    let result = Number(price) * Number(num)
    return result.toFixed(2)
  }
  let prods = window.product
  function getCur(prodDom) {
    let color = prodDom.find('#sp-color div.active').attr('data-val')
    let size = prodDom.find('#sp-number div.active').attr('data-val')
    let type = prodDom.find('#sp-type div.active').attr('data-val')
    return prods.filter(
      item =>
        item.option1 == color && item.option2 == size && item.option3 == type
    )[0]
  }
  function changePrice(prodDom) {
    let num = prodDom.find('#calcNumber').val()
    let price = ((getCur(prodDom).price * num) / 100).toFixed(2)
    let compare = ((getCur(prodDom).compare_at_price * num) / 100).toFixed(2)
    // if(num == 1){
    //   price = (getCur().price * num / 100).toFixed(2)
    // }else if(num == 2){
    //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
    // }else if(num == 3){
    //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
    // }else {
    //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
    // }
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    prodDom.find('#sp_price1').html(price)
    prodDom.find('#sp_price2').html(compare)
    let off_font =
      100 -
      Math.ceil(
        (getCur(prodDom).price / getCur(prodDom).compare_at_price) * 100
      )
    $('.product-part .sp-frees .free').html(off_font)
    prodDom.find('.sp-uppercase .sp-span').html(off_font)
  }

  $('.sp-btn-style').click(function () {
    const prodDom = $(this).closest('.product-part')
    let num = prodDom.find('#calcNumber').val()
    window.location.href = '/cart/' + getCur(prodDom).id + ':' + num
  })
  $('.sp-reduce').click(function () {
    const prodDom = $(this).closest('.product-part')
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    changePrice(prodDom)
  })
  $('.sp-add').click(function () {
    const prodDom = $(this).closest('.product-part')
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    changePrice(prodDom)
  })

  $('.product-part1 .sp-option').click(function () {
    const prodDom = $(this).closest('.product-part')
    $(this).siblings().removeClass('active')
    $(this).addClass('active')

    let colorOptions = $('.product-part1 .sp-color .sp-option.active').index()
    let numberOptions = $(
      '.product-part1 .sp-number-opt .sp-option.active'
    ).index()
    let typeOptions = $('.product-part1 .sp-type .sp-option.active').index()
    let _index
     _index = colorOptions + typeOptions *3 + numberOptions *6
    _swiper.slideToLoop(_index)
    changePrice(prodDom)
  })
  $('.sp-mask .product-part .sp-option').click(function () {
    const prodDom = $(this).closest('.product-part')
    $(this).siblings().removeClass('active')
    $(this).addClass('active')

    let colorOptions = $('.sp-mask .sp-color .sp-option.active').index()
    let numberOptions = $('.sp-mask .sp-number-opt .sp-option.active').index()
    let typeOptions = $('.sp-mask .sp-type .sp-option.active').index()
    let _index
     _index = colorOptions + typeOptions *3 + numberOptions *6
    _swiper2.slideToLoop(_index)
    changePrice(prodDom)
  })

  // 展示尺码弹窗
  $('.sp-btn-pop').click(function () {
    $('.sp-mask').css('display', 'flex')
    // $(".sp-pop").show();
  })
  // 关闭弹窗按钮

  $('.sp-close-btn').click(function (e) {
    $('.sp-mask').hide()
    // $(".sp-pop").hide();
  })

  $(function () {
    // 购物车加购动效
    $('.cart-btn').click(function () {
      $(this).children('img').addClass('on')
      $('.sp-header-top .sp-cart .num').show()
      setTimeout(function () {
        $('.cart-btn').children('img').removeClass('on')
      }, 500)
      $('.sp-header-top .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp-header-top .sp-cart').removeClass('on')
      }, 500)
    })

    let initNum = 0
    $('.product-part .cart-btn').click(function () {
      const prodDom = $(this).closest('.product-part')

      var data = {
        id: getCur(prodDom).id,
        quantity: prodDom.find('#calcNumber').val(),
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
            $('#cardNum').html(result.item_count)
            $('#cardNum').css('background', '#cf0101')
          })
        },
        dataType: 'json',
      })
      // $("#calcNumber").val(1);
      // handleAddToCart(initNum);

      var img = prodDom.find('.swiper-slide-active .sp-img-p')
      // var img = $(".product-part .sp-swiper .swiper-slide-active .sp-img");

      var flyer = img[0].cloneNode(true)
      flyer.classList.add('sp_clone')

      prodDom.append(flyer)
      $('.sp_clone').css({
        width: img[0].width,
        height: img[0].height,
        background: '#e7e9ef',
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
      })

      let finish = $('.sp-cart')
      $('.sp_clone').animate(
        {
          top: finish[0].offsetTop,
          // top: finish[0].offsetTop + $(".time-part").height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach()
            }
          )
        }
      )
    })
  })

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }
})
